import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IUpdateCreatorFitMasterPromptPayload } from "../types";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.GET],
  skipInvalidation: false,
};

export function useUpdateCreatorFitMasterPrompt(config?: {
  onSuccess?: () => void;
  showSuccessToast?: boolean;
  showErrorToast?: boolean;
}) {
  const showSuccess = config?.showSuccessToast ?? false;
  const showError = config?.showErrorToast ?? true;

  const updateCreatorFitMasterPrompt = useCallback(
    (payload: IUpdateCreatorFitMasterPromptPayload) =>
      AiWorkspaceService.updateCreatorFitMasterPrompt(payload)
        .then((res) => {
          if (showSuccess) {
            ToastService.success("Creator Fit master prompt updated successfully");
          }
          return res;
        })
        .catch(async (err) => {
          let errorMessage = "Failed to update master prompt";
          if (err?.response) {
            try {
              const responseBody = await err.response.json();
              if (responseBody?.msg) errorMessage = responseBody.msg;
            } catch (e) {}
          }
          if (showError) {
            ToastService.error(errorMessage);
          }
          throw err;
        }),
    [showSuccess, showError]
  );

  const {
    mutate: update,
    isLoading: isUpdating,
    isSuccess: isUpdated,
  } = useMutation<IUpdateCreatorFitMasterPromptPayload>({
    mutationFn: updateCreatorFitMasterPrompt,
    options: QUERY_OPTIONS,
    onSuccess: config?.onSuccess,
  });

  return { update, isUpdating, isUpdated };
}
